import type { FieldError } from 'react-hook-form';

import { Controller } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import { useIntl } from 'react-intl';
import { Slider, get } from '@mfw/components';
import Box from '@mui/material/Box';

import { getMetricMessage } from './metric-messages';

const STRESS_MIN = 1;
const STRESS_MID = 50;
const STRESS_MAX = 100;

// 1–100 magnitude — the `stress_overall` registry key (Daily Activity
// evening health tab). A slider, not a number field: it's a bounded scale,
// not an arbitrary quantity.
export const StressSlider = ({ name }: { name: string }) => {
  const { formatMessage } = useIntl();
  const message = getMetricMessage(name);
  const label = message ? formatMessage(message) : name;
  return (
    <Controller
      render={({ field, formState: { errors } }) => {
        const error = get<FieldError>(errors, name) ?? undefined;
        const value = typeof field.value === 'number' ? field.value : null;
        return (
          <Box>
            <Typography color="text.secondary" variant="body2" mb={0.5}>
              {value === null ? label : `${label} (${value})`}
            </Typography>
            <Slider
              onChange={(_, next) => field.onChange(next)}
              value={value ?? STRESS_MID}
              errors={error?.message}
              data-testid="daily-activity-stress-overall"
              valueLabelDisplay="auto"
              max={STRESS_MAX}
              min={STRESS_MIN}
              size="small"
              sx={{ mx: 1.5, width: '80%' }}
            />
          </Box>
        );
      }}
      name={name}
    />
  );
};

export default StressSlider;
